import React from "react";
import { RaisedButton } from "material-ui";
import { Link } from "react-router";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
// import SchedulerStore from '../stores/SchedulerStore';
// import SchedulerActions from '../actions/SchedulerActions';

import LinkLike from "./partials/link-like.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import SchedulerOverlay from "./partials/overlays/scheduler-overlay.jsx";

class Scheduler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openedSchedule: null
    };
  }

  static getStores() {
    return [EventBucketStore];
  }

  static getPropsFromStores() {
    return {
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(props) {}

  getStyles() {
    return {
      header: {
        textAlign: "center",
        marginBottom: "1em"
      },
      body: {
        textAlign: "center"
      },
      intro: {
        color: "rgb(33,33,33)",
        textAlign: "center"
      },
      childen: {
        textAlign: "left",
        fontSize: "12pt"
      }
    };
  }

  render() {
    const { eventBucketId } = this.props.params,
      eventBucket = this.props.getEventBucketById(eventBucketId),
      styles = this.getStyles();

    if (!eventBucket) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        {this.state.openedSchedule}
        <h1 style={styles.header}>{eventBucket.name} Scheduler</h1>
        <div style={styles.body}>
          <div style={styles.childen}>
            <p style={styles.intro}>
              Use Eventive Scheduler to easily schedule showings.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default connectToStores(Scheduler);



// WEBPACK FOOTER //
// ./src/app/components/scheduler.jsx